'use client'

import React from 'react'

import { ThemeProvider } from 'next-themes'

import { ChakraProvider, chakra } from '@chakra-ui/react'

import { Fonts } from '../../theme/Fonts'
import { system } from '../../theme/system'
import type { ColorScheme } from '../../types'
import { selectionCss } from './Provider.styles'

export interface DarkProviderIProps extends React.PropsWithChildren {
  /**
   * Palette for the text-selection (::selection) highlight applied to
   * everything rendered under this provider. Match it to the colorScheme
   * passed to the components inside. When omitted, the highlight follows
   * SELECTION_BG_VAR / SELECTION_FG_VAR if the app sets them, and falls
   * back to the dark palette otherwise.
   */
  colorScheme?: ColorScheme
}

export const DarkProvider = ({ colorScheme, children }: DarkProviderIProps) => {
  return (
    <ChakraProvider value={system}>
      <ThemeProvider
        attribute='class'
        disableTransitionOnChange
        enableColorScheme={false}
      >
        <Fonts />
        <chakra.div css={selectionCss(colorScheme)} display='contents'>
          {children}
        </chakra.div>
      </ThemeProvider>
    </ChakraProvider>
  )
}
